import { render, staticRenderFns } from "./PassportIndex.vue?vue&type=template&id=395ba9e6&"
import script from "./PassportIndex.vue?vue&type=script&lang=js&"
export * from "./PassportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports